export default __webpack_public_path__ + "static/media/0.87480e97.mp3";